import { render } from "./AiconeLogo.vue?vue&type=template&id=4328e1c2&scoped=true"
import script from "./AiconeLogo.vue?vue&type=script&lang=js"
export * from "./AiconeLogo.vue?vue&type=script&lang=js"

import "./AiconeLogo.vue?vue&type=style&index=0&id=4328e1c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4328e1c2"]])

export default __exports__